import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { errorMessageKey } from '@/shared/lib/errors';
import { Async } from '@/shared/ui/Async';

import { ProfileForm } from '../components/ProfileForm';
import { useMyProfile, useUpsertProfile } from '../hooks/use-profile';
import { deriveLegacyRole } from '../model/profile';

/** Edit the signed-in user's profile (D-014: multi-role flags editable). */
export function EditProfileRoute(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const query = useMyProfile();
  const upsert = useUpsertProfile();

  return (
    <main className="page stack">
      <h1>{t('profile.edit')}</h1>
      <Async query={query}>
        {(profile) =>
          profile ? (
            <ProfileForm
              submitLabel={t('profile.saveChanges')}
              submitting={upsert.isPending}
              serverError={upsert.isError ? t(errorMessageKey(upsert.error)) : null}
              initial={{
                fullName: profile.fullName,
                city: profile.city,
                bio: profile.bio,
                yearsExperience: profile.yearsExperience,
                qualifications: profile.qualifications,
                serviceLat: profile.serviceLat,
                serviceLng: profile.serviceLng,
                serviceRadiusKm: profile.serviceRadiusKm,
                canKhutbah: profile.canKhutbah,
                isImam: profile.isImam,
                isMuezzin: profile.isMuezzin,
                isAppointed: profile.isAppointed,
                isFreelance: profile.isFreelance,
              }}
              onSubmit={(values) =>
                upsert.mutate(
                  {
                    id: profile.id,
                    // Legacy `role` column stays populated for back-compat until
                    // it's dropped in a later phase (see D-014).
                    role: deriveLegacyRole(values),
                    onboardingComplete: true,
                    ...values,
                  },
                  { onSuccess: () => navigate('/profile') },
                )
              }
            />
          ) : (
            <></>
          )
        }
      </Async>
    </main>
  );
}
